import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    modalId: { type: String, default: "delete-user-modal" },
    formId: { type: String, default: "delete-user-form" }
  }

  connect() {
    this.modal = document.getElementById(this.modalIdValue)
    this.form = document.getElementById(this.formIdValue)
    this.element.addEventListener("click", this.open.bind(this))
  }

  open(e) {
    e.preventDefault()
    const userId = this.element.dataset.userId
    const redirectTo = this.element.dataset.redirectTo
    if (!userId || !this.form) return

    this.form.action = redirectTo === "search"
      ? `/management/users/${userId}?redirect_to=search`
      : `/management/users/${userId}`

    if (this.modal && typeof UIkit !== "undefined") {
      UIkit.modal(this.modal).show()
    }
  }
}
